import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase-config';
import { FiHome, FiPlusCircle, FiList, FiSettings, FiLogOut } from 'react-icons/fi';

const navItems = [
  { label: 'Home', to: '/', icon: FiHome },
  { label: 'New', to: '/create', icon: FiPlusCircle },
  { label: 'History', to: '/transactions', icon: FiList },
  { label: 'Settings', to: '/settings', icon: FiSettings },
];

export default function Layout({ user, merchantData, children }) {
  const location = useLocation();

  const isActive = (path) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Top Nav */}
      <header className="bg-primary text-white sticky top-0 z-50 pt-[env(safe-area-inset-top)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 sm:h-16">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <h1 className="text-xl font-bold tracking-tight">
                KwikX<span className="text-accent">.</span>
              </h1>
              <span className="hidden sm:inline text-xs bg-accent/20 text-accent px-2 py-0.5 rounded-full font-medium">
                Merchant
              </span>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive(item.to)
                      ? 'bg-white/15 text-white'
                      : 'text-white/70 hover:text-white hover:bg-white/10'
                  }`}
                >
                  <item.icon size={16} />
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* User & Logout */}
            <div className="flex items-center gap-3">
              <div className="hidden sm:block text-right">
                <p className="text-sm font-medium leading-tight">{merchantData?.fullName || 'Merchant'}</p>
                <p className="text-xs text-white/60 leading-tight">{user?.email}</p>
              </div>
              <button
                onClick={() => signOut(auth)}
                className="touch-target rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
                title="Sign out"
              >
                <FiLogOut size={18} />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content — bottom padding on mobile for tab bar */}
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-8 pb-24 md:pb-8">
        {children}
      </main>

      {/* Mobile Bottom Tab Bar */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-50 pb-[env(safe-area-inset-bottom)]">
        <div className="flex items-stretch justify-around">
          {navItems.map((item) => {
            const active = isActive(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors ${
                  active ? 'text-primary' : 'text-gray-400'
                }`}
              >
                <item.icon size={20} />
                <span className="text-[10px] font-semibold">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
